import { useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  item: string;
}

interface StructDataProps {
  type: 'home' | 'category' | 'article' | 'about';
  categoryName?: string;
  articleTitle?: string;
  articleDate?: string;
  articleImage?: string;
  articleAuthor?: string;
}

const SITE_URL = 'https://chiguaheiliao.com';
const SITE_NAME = '吃瓜黑料网';
const SITE_DESCRIPTION = '吃瓜黑料网🔔，每日更新网红黑料、明星塌房、热门事件，提供在线爆料与视频，实时追踪每日大赛，吃瓜不打烊，黑料不停更。';

function generateBreadcrumbs(type: string, categoryName?: string, articleTitle?: string): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [{ name: '首页', item: SITE_URL }];

  if (type === 'category' && categoryName) {
    items.push({ name: categoryName, item: `${SITE_URL}/category/${categoryName}` });
  } else if (type === 'article' && categoryName && articleTitle) {
    items.push({ name: categoryName, item: `${SITE_URL}/category/${categoryName}` });
    items.push({ name: articleTitle, item: `${SITE_URL}/article/${articleTitle}` });
  } else if (type === 'about') {
    items.push({ name: '关于我们', item: `${SITE_URL}/about` });
  }

  return items;
}

function OrganizationSchema() {
  const json = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    logo: `${SITE_URL}/logo.png`,
    sameAs: [
      'https://weibo.com/chiguaheiliao',
      'https://www.douyin.com/user/chiguaheiliao',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'tips@chiguaheiliao.com',
      availableLanguage: ['Chinese'],
    },
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }} />;
}

function WebSiteSchema() {
  const json = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }} />;
}

function WebPageSchema(url: string, name: string, description: string, breadcrumbs: BreadcrumbItem[]) {
  const safeBreadcrumbs = breadcrumbs || [{ name: '首页', item: SITE_URL }];

  const breadcrumbJson = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: safeBreadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.item,
    })),
  };

  const pageJson = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': url,
    url,
    name,
    description,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: safeBreadcrumbs.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: item.item,
      })),
    },
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJson) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageJson) }} />
    </>
  );
}

function ArticleSchema(title: string, url: string, datePublished: string, image: string, author: string, description: string) {
  const json = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    url,
    datePublished,
    dateModified: datePublished,
    image,
    author: {
      '@type': 'Person',
      name: author,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
    },
    description,
    inLanguage: 'zh-CN',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }} />;
}

function FAQSchema() {
  const json = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '吃瓜黑料网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '吃瓜黑料网是国内领先的娱乐爆料资讯聚合平台，每日更新网红黑料、明星塌房、热门事件，提供在线爆料与视频，实时追踪每日大赛。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在吃瓜黑料网投稿爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过发送邮件至 tips@chiguaheiliao.com 提交爆料线索，或关注微信公众号"吃瓜黑料网官方"进行投稿。所有爆料信息严格保密，我们会在24小时内回复。',
        },
      },
      {
        '@type': 'Question',
        name: '吃瓜黑料网的信息是否可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '吃瓜黑料网拥有一支专业的编辑审核团队，每一条爆料都会经过多方核实后才发布。我们坚持"有料必核、有瓜必追"的原则，确保信息的真实性和可靠性。',
        },
      },
      {
        '@type': 'Question',
        name: '吃瓜黑料网多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '吃瓜黑料网实行7×24小时全天候更新机制，专业团队实时监测网络热点。每日更新大量爆料资讯，包括网红黑料、明星塌房、吃瓜视频和每日大赛等内容。',
        },
      },
    ],
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }} />;
}

export default function StructuredData({ type, categoryName, articleTitle, articleDate, articleImage, articleAuthor }: StructDataProps) {
  const location = useLocation();
  const url = `${SITE_URL}${location.pathname}`;

  let pageName = SITE_NAME;
  let pageDescription = SITE_DESCRIPTION;
  const breadcrumbs = generateBreadcrumbs(type, categoryName, articleTitle) || [{ name: '首页', item: SITE_URL }];

  if (type === 'category' && categoryName) {
    pageName = `${categoryName} - ${SITE_NAME}`;
    pageDescription = `浏览${categoryName}相关的最新爆料资讯，吃瓜黑料网实时追踪，每日更新。`;
  } else if (type === 'article' && articleTitle) {
    pageName = `${articleTitle} - ${SITE_NAME}`;
    pageDescription = articleTitle;
  } else if (type === 'about') {
    pageName = `关于我们 - ${SITE_NAME}`;
    pageDescription = '了解吃瓜黑料网品牌介绍、用户口碑及联系方式，国内领先的娱乐爆料资讯平台。';
  }

  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema url={url} name={pageName} description={pageDescription} breadcrumbs={breadcrumbs} />
      {type === 'article' && articleDate && articleImage && articleAuthor && articleTitle && (
        <ArticleSchema
          title={articleTitle}
          url={url}
          datePublished={articleDate}
          image={articleImage}
          author={articleAuthor}
          description={pageDescription}
        />
      )}
      {type === 'about' && <FAQSchema />}
    </>
  );
}